import { render, staticRenderFns } from "./AlarmWay.vue?vue&type=template&id=962bdbf8&scoped=true&"
import script from "./AlarmWay.vue?vue&type=script&lang=js&"
export * from "./AlarmWay.vue?vue&type=script&lang=js&"
import style0 from "./AlarmWay.vue?vue&type=style&index=0&id=962bdbf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962bdbf8",
  null
  
)

export default component.exports